module.exports = __webpack_public_path__ + "img/music-close.571bd39b.png";